export default __webpack_public_path__ + "static/3-f173b43f3642e20c7b01a6117c69b750.jpg";